import { DownloadDocumentTypeKey } from '@finxone-platform/shared/sys-config-types';

export const TEMPLATE_MOCK_VALUES: Record<string, Record<string, unknown>> = {
  [DownloadDocumentTypeKey.BANK_STATEMENT_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    OpeningBalance: '1,000.00',
    ClosingBalance: '2,500.00',
    MoneyIn: '2,000.00',
    MoneyOut: '500.00',
    StartDate: '2024-01-01',
    EndDate: '2024-01-31',
    UserName: 'John Doe',
    StreetAddress: '123 Main Street',
    City: 'London',
    PostCode: 'EC1A 1BB',
    Currency: 'GBP',
    AccountNumber: '12345678',
    SortCode: '112233',
    iban: 'GB29NWBK60161331926819',
    bic: 'NWBKGB2L',
    AccountAlias: 'Current Account',
    accountDetails: {
      accountNumber: '12345678',
      sortCode: '112233',
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
    },
    transactions: [
      {
        transactionDate: '2024-01-15',
        description: 'Direct Debit - Utility Co',
        transactionType: 'debit',
        totalAmount: 150.0,
        balance: 850.0,
        currency: 'GBP',
        amount: 150.0,
      },
      {
        transactionDate: '2024-01-20',
        description: 'Bank Transfer - Salary',
        transactionType: 'credit',
        totalAmount: 2000.0,
        balance: 2850.0,
        currency: 'GBP',
        amount: 2000.0,
      },
    ],
    transactionDate: '2024-01-01',
  },
  [DownloadDocumentTypeKey.PROOF_OF_PAYMENT_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    amount: '500.00',
    totalAmount: '505.00',
    currency: 'GBP',
    feeAmount: '5.00',
    feeCurrency: 'GBP',
    paymentStatus: 'Completed',
    transactionNumber: 'TXN-2024-001234',
    transaction_date: '2024-01-15',
    senderName: 'John Doe',
    senderAccountNo: '12345678',
    receiverName: 'Jane Smith',
    receiverAccountNo: '87654321',
    senderRoutingInfo: {
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
      sortCode: '112233',
      aba: '',
      bsbCode: '',
      ifsc: '',
      rtnCanada: '',
      clabe: '',
      bankCode: '',
      branchCode: '',
    },
    receiverRoutingInfo: {
      iban: 'GB82WEST12345698765432',
      bic: 'WESTGB2L',
      sortCode: '445566',
      aba: '',
      bsbCode: '',
      ifsc: '',
      rtnCanada: '',
      clabe: '',
      bankCode: '',
      branchCode: '',
    },
  },
  [DownloadDocumentTypeKey.PROOF_OF_EXCHANGE_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    transactionNumber: 'EXC-2024-005678',
    fixedSide: 'sell',
    exchangeRate: '1.1750',
    buyCurrency: 'EUR',
    buyAmount: '1,175.00',
    sellCurrency: 'GBP',
    sellAmount: '1,000.00',
    feeAmount: '10.00',
    feeCurrency: 'GBP',
    originalExchangeDate: '2024-01-10',
    exchangeDate: '2024-01-10',
    settlementDate: '2024-01-12',
    status: 'Completed',
    sender: {
      name: 'John Doe',
      accountNumber: '12345678',
      sortCode: '112233',
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
      aba: '',
      bsbCode: '',
      ifsc: '',
      rtnCanada: '',
      clabe: '',
      bankCode: '',
      branchCode: '',
    },
    receiver: {
      name: 'John Doe',
      accountNumber: '87654321',
      sortCode: '',
      iban: 'DE89370400440532013000',
      bic: 'COBADEFFXXX',
      aba: '',
      bsbCode: '',
      ifsc: '',
      rtnCanada: '',
      clabe: '',
      bankCode: '',
      branchCode: '',
    },
  },
  [DownloadDocumentTypeKey.HOLDING_STATEMENT_PDF]: {
    logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    startDate: '2024-01-01',
    endDate: '2024-01-31',
    depositAmount: 5000.0,
    initialFundAmount: 10000.0,
    pendingInitialFundAmount: 2000.0,
    fee: 25.0,
    feeRate: 0.5,
    currency: 'GBP',
    totalUnit: 150000.0,
    initialExchangeRate: 0.0067,
    currentExchangeRate: 0.0071,
    currentExchangeRateCreatedDate: '2024-01-31',
    fundGrowthPercentage: 5.25,
    fundGrowthValue: 525.0,
    lastInterestCredit: {
      date: '2024-01-31T00:00:00.000Z',
      amount: 12.5,
      currency: 'GBP',
    },
    totalBalance: {
      currency: 'GBP',
      amount: 10525.0,
    },
    totalInterest: {
      currency: 'GBP',
      amount: 125.0,
      incrementPercentage: 1.25,
    },
    totalBalanceWithInterest: {
      currency: 'GBP',
      amount: 10650.0,
    },
    depositType: 'variable',
    transactions: [
      {
        transactionDate: '2024-01-05',
        description: 'Initial Fund Deposit',
        transactionType: 'credit',
        totalAmount: 10000.0,
        balance: 10000.0,
        currency: 'GBP',
        amount: 10000.0,
      },
      {
        transactionDate: '2024-01-15',
        description: 'Interest Credit',
        transactionType: 'credit',
        totalAmount: 12.5,
        balance: 10012.5,
        currency: 'GBP',
        amount: 12.5,
      },
      {
        transactionDate: '2024-01-20',
        description: 'Management Fee',
        transactionType: 'debit',
        totalAmount: 25.0,
        balance: 9987.5,
        currency: 'GBP',
        amount: 25.0,
      },
    ],
  },
  [DownloadDocumentTypeKey.SAVINGS_BANK_STATEMENT_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    OpeningBalance: '10,000.00',
    ClosingBalance: '10,041.67',
    MoneyIn: '41.67',
    MoneyOut: '0.00',
    StartDate: '2026-01-01',
    EndDate: '2026-01-31',
    UserName: 'John Doe',
    StreetAddress: '123 Main Street',
    City: 'London',
    PostCode: 'EC1A 1BB',
    Currency: 'GBP',
    AccountNumber: '12345678',
    SortCode: '112233',
    iban: 'GB29NWBK60161331926819',
    bic: 'NWBKGB2L',
    AccountAlias: '1 Year Fixed Term Account',
    BalanceAtMaturity: '10,512.00',
    InterestAccrued: '41.67',
    MaxDeposit: '250,000.00',
    InterestAtMaturity: '512.00',
    AccountStartDate: '2026-01-01T00:00:00.000Z',
    InterestRate: '5.00%',
    AnnualEquivalantInterestRate: '5.12%',
    ProductName: '1 Year Fixed Term Account',
    ProductCode: 'SAV123',
    TermMonths: 12,
    accountDetails: {
      accountNumber: '12345678',
      sortCode: '112233',
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
    },
    transactions: [
      {
        transactionDate: '2026-01-01',
        description: 'Fixed Term Deposit - Account Opened',
        transactionType: 'credit',
        totalAmount: 10000.0,
        balance: 10000.0,
        currency: 'GBP',
        amount: 10000.0,
      },
      {
        transactionDate: '2026-01-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 41.67,
        balance: 10041.67,
        currency: 'GBP',
        amount: 41.67,
      },
    ],
    transactionDate: '2026-01-31',
  },
  [DownloadDocumentTypeKey.SAVINGS_ANNUAL_STATEMENT_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    OpeningBalance: '10,000.00',
    ClosingBalance: '10,511.64',
    MoneyIn: '511.64',
    MoneyOut: '0.00',
    StartDate: '2026-01-01',
    EndDate: '2026-12-31',
    UserName: 'John Doe',
    StreetAddress: '123 Main Street',
    City: 'London',
    PostCode: 'EC1A 1BB',
    Currency: 'GBP',
    AccountNumber: '12345678',
    SortCode: '112233',
    iban: 'GB29NWBK60161331926819',
    bic: 'NWBKGB2L',
    AccountAlias: '1 Year Fixed Term Account',
    BalanceAtMaturity: '10,511.64',
    InterestAccrued: '511.64',
    MaxDeposit: '250,000.00',
    InterestAtMaturity: '511.64',
    AccountStartDate: '2026-01-01T00:00:00.000Z',
    InterestRate: '5.00%',
    AnnualEquivalantInterestRate: '5.12%',
    ProductName: '1 Year Fixed Term Account',
    ProductCode: 'SAV123',
    TermMonths: 12,
    accountDetails: {
      accountNumber: '12345678',
      sortCode: '112233',
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
    },
    transactions: [
      {
        transactionDate: '2026-01-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 41.67,
        balance: 10041.67,
        currency: 'GBP',
        amount: 41.67,
      },
      {
        transactionDate: '2026-02-28',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 41.84,
        balance: 10083.51,
        currency: 'GBP',
        amount: 41.84,
      },
      {
        transactionDate: '2026-03-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.01,
        balance: 10125.52,
        currency: 'GBP',
        amount: 42.01,
      },
      {
        transactionDate: '2026-04-30',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.19,
        balance: 10167.71,
        currency: 'GBP',
        amount: 42.19,
      },
      {
        transactionDate: '2026-05-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.37,
        balance: 10210.08,
        currency: 'GBP',
        amount: 42.37,
      },
      {
        transactionDate: '2026-06-30',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.54,
        balance: 10252.62,
        currency: 'GBP',
        amount: 42.54,
      },
      {
        transactionDate: '2026-07-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.72,
        balance: 10295.34,
        currency: 'GBP',
        amount: 42.72,
      },
      {
        transactionDate: '2026-08-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 42.9,
        balance: 10338.24,
        currency: 'GBP',
        amount: 42.9,
      },
      {
        transactionDate: '2026-09-30',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 43.08,
        balance: 10381.32,
        currency: 'GBP',
        amount: 43.08,
      },
      {
        transactionDate: '2026-10-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 43.26,
        balance: 10424.58,
        currency: 'GBP',
        amount: 43.26,
      },
      {
        transactionDate: '2026-11-30',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 43.44,
        balance: 10468.02,
        currency: 'GBP',
        amount: 43.44,
      },
      {
        transactionDate: '2026-12-31',
        description: 'Monthly Interest Credit',
        transactionType: 'credit',
        totalAmount: 43.62,
        balance: 10511.64,
        currency: 'GBP',
        amount: 43.62,
      },
    ],
    transactionDate: '2026-12-31',
  },

  [DownloadDocumentTypeKey.SAVINGS_ACCOUNT_CLOSURE_STATEMENT_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    OpeningBalance: '0.00',
    ClosingBalance: '0.00',
    MoneyIn: '10,511.64',
    MoneyOut: '10,511.64',
    StartDate: '2026-01-01',
    EndDate: '2026-12-31',
    UserName: 'John Doe',
    StreetAddress: '123 Main Street',
    City: 'London',
    PostCode: 'EC1A 1BB',
    Currency: 'GBP',
    AccountNumber: '12345678',
    SortCode: '112233',
    iban: 'GB29NWBK60161331926819',
    bic: 'NWBKGB2L',
    AccountAlias: '1 Year Fixed Term Account',
    InterestAccrued: '511.64',
    InterestRate: '5.00%',
    AnnualEquivalantInterestRate: '5.12%',
    ProductName: '1 Year Fixed Term Account',
    ProductCode: 'SAV123',
    accountDetails: {
      accountNumber: '12345678',
      sortCode: '112233',
      iban: 'GB29NWBK60161331926819',
      bic: 'NWBKGB2L',
    },
    transactions: [
      {
        transactionDate: '2026-01-01',
        description: 'Opening Deposit',
        transactionType: 'credit',
        totalAmount: 10000.0,
        balance: 10000.0,
        currency: 'GBP',
        amount: 10000.0,
      },
      {
        transactionDate: '2026-12-31',
        description: 'Final Interest Credit',
        transactionType: 'credit',
        totalAmount: 511.64,
        balance: 10511.64,
        currency: 'GBP',
        amount: 511.64,
      },
      {
        transactionDate: '2026-12-31',
        description: 'Closing Withdrawal To Nominated Account',
        transactionType: 'debit',
        totalAmount: 10511.64,
        balance: 0.0,
        currency: 'GBP',
        amount: 10511.64,
      },
    ],
  },

  [DownloadDocumentTypeKey.SAVINGS_KEY_PRODUCT_INFORMATION_PDF]: {
    Logo: '<img src="data:image/svg+xml;base64,..." alt="Logo" />',
    productName: '1 Year Fixed Term Account',
    issueNumber: 2,
    currency: 'GBP',
    minBalance: '10,000.00',
    maxBalance: '250,000.00',
    interestRate: 5.11,
    aer: 5.11,
    accountType: 'fixed-term',
    fundingWindowDays: 14,
    termMonths: 12,
  },
};
